import SEO from "@/components/SEO";
import ResourcesHero from "./components/ResourcesHero";
import PublicationsGrid from "./components/PublicationsGrid";
import CoursesSection from "./components/CoursesSection";
import ExternalLinksSection from "./components/ExternalLinksSection";
import ResourcesCTA from "./components/ResourcesCTA";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const resourcesSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "資源中心｜TAIAA 台灣 AI 應用推廣協會",
  description:
    "瀏覽 TAIAA 出版品、白皮書、研究報告、線上課程與實用外部連結。免費下載 AI 應用相關資源。",
  url: siteUrl ? `${siteUrl}/resources` : undefined,
};

export default function Resources() {
  return (
    <main className="pt-0">
      <SEO
        title="資源中心｜TAIAA 台灣 AI 應用推廣協會"
        description="瀏覽 TAIAA 出版品、白皮書、研究報告、線上課程與實用外部連結。免費下載 AI 應用相關資源。"
        keywords="TAIAA,資源中心,AI 出版品,白皮書,研究報告,AI 課程"
        schema={resourcesSchema}
      />
      <ResourcesHero />
      <PublicationsGrid />
      <CoursesSection />
      <ExternalLinksSection />
      <ResourcesCTA />
    </main>
  );
}